(function () {

    angular
        .module('smartertoolsApp')
        .controller('accountInfoController', ['$scope', '$timeout', 'accountService', 'notificationFactory', 'authenticationService', accountInfoController]);

    function accountInfoController($scope, $timeout, accountService, notify, authenticationService) {
        const vm = this;
        vm.details = null;
        vm.isPrimaryAccountHolder = false;
        vm.isSaving = false;
        vm.countryList = geographicLocations.countries;
        vm.stateList = geographicLocations.statesByCountry;
        vm.loggedInAsEmailAddress = authenticationService.getLoggedInEmail();

        // Functions
        vm.attachFocusEvents = attachFocusEvents;
        vm.SaveInfo = SaveInfo;
        vm.Reload = Reload;
        vm.ShowChangeLoginEmail = ShowChangeLoginEmail;
        vm.ShowChangeLoginPassword = ShowChangeLoginPassword;
        vm.ShowChangeUserLoginPassword = ShowChangeUserLoginPassword;
        vm.DoChangeLoginEmail = DoChangeLoginEmail;
        vm.DoChangeLoginPassword = DoChangeLoginPassword;
        vm.DoChangeUserLoginPassword = DoChangeUserLoginPassword;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.Reload();
        }

        function attachFocusEvents() {
            if (!vm.focusEventsAttached) {
                document.getElementById('change-login-email-modal')
                    .addEventListener('shown.bs.modal', () => { document.getElementById('accountLoginCredsNewEmail').focus(); });
                document.getElementById('change-login-password-modal')
                    .addEventListener('shown.bs.modal', () => { document.getElementById('accountLoginCredsOldPw').focus(); });
                document.getElementById('change-user-login-password-modal')
                    .addEventListener('shown.bs.modal', () => { document.getElementById('accountUserLoginCredsOldPw').focus(); });
                vm.focusEventsAttached = true;
            }
        }

        function SaveInfo() {
            if (vm.setAccountPropertiesForm.$invalid)
                return;
            vm.isSaving = true;
            accountService.saveAccountInfo(vm.details)
                .then(() => {
                    vm.isSaving = false;
                    notify.success('Your information was updated.');
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating your information.');
                });
        }

        function Reload() {
            $scope.accountCtrl.isLoading++;
            accountService.getAccountSettings()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.details = data.Details;
                    vm.isPrimaryAccountHolder = data.IsPrimaryAccountHolder;
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => { $scope.accountCtrl.isLoading--; });
        }

        function ShowChangeLoginEmail() {
            vm.isSaving = false;
            vm.newCredentials = { EmailAddress: vm.details.EmailAddress };
            vm.AccountInfoChangeEmailForm.$setPristine();
            vm.AccountInfoChangeEmailForm.$setUntouched();
            vm.attachFocusEvents();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('change-login-email-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function ShowChangeLoginPassword() {
            vm.isSaving = false;
            vm.newCredentials = { EmailAddress: vm.details.EmailAddress };
            vm.AccountInfoChangePwForm.$setPristine();
            vm.AccountInfoChangePwForm.$setUntouched();
            vm.attachFocusEvents();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('change-login-password-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function ShowChangeUserLoginPassword() {
            vm.isSaving = false;
            vm.newCredentials = { EmailAddress: vm.details.EmailAddress };
            vm.changeUserLoginModalForm.$setPristine();
            vm.changeUserLoginModalForm.$setUntouched();
            vm.attachFocusEvents();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('change-user-login-password-modal')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function DoChangeLoginEmail() {
            if (vm.AccountInfoChangeEmailForm.$invalid) {
                notify.error('Email addresses must match.');
                return;
            }
            vm.isSaving = true;
            accountService.saveLoginEmail(vm.newCredentials)
                .then(() => {
                    vm.isSaving = false;
                    authenticationService.setLoggedInEmail(vm.newCredentials.NewEmailAddress);
                    RefreshLoginTopArea();
                    vm.details.EmailAddress = vm.newCredentials.NewEmailAddress;
                    notify.success('Your information was updated.');
                    location.reload();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('change-login-email-modal')).hide();
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating your information.');
                });
        }

        function DoChangeLoginPassword() {
            if (vm.AccountInfoChangePwForm.$invalid)
                return;
            vm.isSaving = true;
            accountService.saveLoginPassword(vm.newCredentials)
                .then(() => {
                    vm.isSaving = false;
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('change-login-password-modal')).hide();
                    notify.success('Your information was updated.');
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating your information. Please check your information and try again.');
                });
        }

        function DoChangeUserLoginPassword() {
            if (vm.changeUserLoginModalForm.$invalid)
                return;
            vm.isSaving = true;
            accountService.saveUserLoginPassword(vm.newCredentials)
                .then(() => {
                    vm.isSaving = false;
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('change-user-login-password-modal')).hide();
                    notify.success('Your information was updated.');
                })
                .catch(() => {
                    vm.isSaving = false;
                    notify.error('There was a problem updating the information.');
                });
        }
    }

})();